<template>
  <div class="ts-p-3">
    <h6
      class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md"
      style="width: fit-content"
    >
      {{ $t('promotion.condition') }}
    </h6>
    <table class="ts-w-full">
      <thead>
        <tr>
          <th
            class="ts-text-center ts-uppercase ts-text-blue-500 ts-bg-gray-300"
            colspan="3"
          >
            {{ $t('promotion.buy') }}
          </th>
          <th class="ts-text-center ts-uppercase ts-text-blue-500" colspan="4">
            {{ $t('promotion.free') }}
          </th>
          <th
            class="ts-text-center ts-uppercase ts-text-blue-500 ts-w-10"
            rowspan="2"
          >
            <a href="#" @click.prevent="addItem">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
        <tr>
          <th class="ts-text-center ts-font-normal">
            {{ $t('promotion.product') }}
          </th>
          <th class="ts-text-center ts-font-normal ts-w-32">
            {{ $t('promotion.quantity') }}
          </th>
          <th class="ts-text-center ts-font-normal ts-w-32">
            {{ $t('promotion.conditionType') }}
          </th>
          <th class="ts-text-center ts-font-normal">
            {{ $t('promotion.product') }}
          </th>
          <th class="ts-text-center ts-font-normal ts-w-32">
            {{ $t('promotion.quantity') }}
          </th>
          <th class="ts-text-center ts-font-normal ts-w-32">
            {{ $t('promotion.price') }}
          </th>
          <th class="ts-w-8"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(con, index) in model.condition">
          <tr :key="index">
            <td valign="middle">
               <input type="text" :value="getProductName(con.pro_sale_code_id_buy)" class="form-control" readonly>
              <!-- <a-select
                v-model.number="con.pro_sale_code_id_buy"
                showSearch
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                class="ts-w-full"
              >
                <a-select-option
                  v-for="(product, index) in getProductBuy({
                    chosenProduct: model.condition,
                    productCurrentRow: con.pro_sale_code_id_buy,
                  })"
                  :key="index"
                  :value="product.pro_sale_code_id"
                  >{{ product.product_name_en }}</a-select-option
                >
              </a-select> -->
              <div
                class="validate ts-text-xs"
                v-if="
                  errors.has('condition.' + index + '.pro_sale_code_id_buy')
                "
              >
                {{
                  errors.first('condition.' + index + '.pro_sale_code_id_buy')
                }}
              </div>
            </td>
            <td valign="top">
              <input
                v-model.number="con.buy_quantity"
                type="number"
                class="form-control"
              />
              <div
                class="validate ts-text-xs"
                v-if="errors.has('condition.' + index + '.buy_quantity')"
              >
                {{ errors.first('condition.' + index + '.buy_quantity') }}
              </div>
            </td>
            <td valign="top">
              <select class="form-control"
                v-model="con.condition_type"
                @change="conditionTypeChange(con)"
              >
                <option value="Free">Free</option>
                <option value="Discount">Discount</option>
              </select>
              <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.condition_type')">
                {{ errors.first('condition.' + index + '.condition_type') }}
              </div>
            </td>
            <!-- add item Free -->
            <td valign="top">
              <input type="text" :value="getProductName(con.freeItem[0].pro_sale_code_id_free)" class="form-control" readonly>
              <!-- <a-select 
                v-model.number="con.freeItem[0].pro_sale_code_id_free"
                showSearch
                :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0" 
                class="ts-w-full"
                @change="productFreeChange(con.condition_type, con.freeItem[0])"
              >
              <a-select-option
                v-for="(product, index) in getProductFree({ 
                  chosenProduct: model.condition[index].freeItem,
                  productCurrentRow: con.freeItem[0].pro_sale_code_id_free
                })"
                :key="index"
                :value="product.pro_sale_code_id"
              >{{ product.product_name_en }}</a-select-option>
              </a-select> -->
            </td>
            <td valign="top">
              <input
                v-model.number="con.freeItem[0].free_quantity" 
                type="number" class="form-control" />
              <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.freeItem.0.free_quantity')">
                {{ errors.first('condition.' + index + '.freeItem.0.free_quantity') }}
              </div>
            </td>
            <td valign="top">
              <input
                v-model.number="con.freeItem[0].price"
                :disabled="con.condition_type == 'Free'" 
                type="number" class="form-control" />
              <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.freeItem.0.price')">
                {{ errors.first('condition.' + index + '.freeItem.0.price') }}
              </div>
            </td>
            <td class="text-center">
              <a href="#" @click.prevent="addSubItem(con)">
                <i class="fa fa-plus"></i>
              </a>
            </td>
            <!-- end free item  -->
            <td class="text-center">
              <a
                href="#"
                class="ts-text-red-700 hover:ts-text-red-700"
                @click.prevent="removeItem(index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
          <!-- sub items -->
          <template v-if="con.freeItem.length > 1">
            <tr v-for="i in con.freeItem.length - 1">
              <td colspan="3"></td>
              <td valign="top">
                <input type="text" :value="getProductName(con.freeItem[i].pro_sale_code_id_free)" class="form-control" readonly>
                <!-- <a-select 
                  v-model.number="con.freeItem[i].pro_sale_code_id_free"
                  showSearch
                  :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0" 
                  class="ts-w-full"
                  @change="productFreeChange(con.condition_type, con.freeItem[i])"
                >
                <a-select-option
                  v-for="(product, index) in getProductFree({ 
                    chosenProduct: model.condition[index].freeItem,
                    productCurrentRow: con.freeItem[i].pro_sale_code_id_free
                  })"
                  :key="index"
                  :value="product.pro_sale_code_id"
                >{{ product.product_name_en }}</a-select-option>
                </a-select> -->
              </td>
              <td valign="top">
                <input
                  v-model.number="con.freeItem[i].free_quantity" 
                  type="number" class="form-control" />
                <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.freeItem.'+ i +'.free_quantity')">
                  {{ errors.first('condition.' + index + '.freeItem.'+i+'.free_quantity') }}
                </div>
              </td>
              <td valign="top">
                <input
                  v-model.number="con.freeItem[i].price"
                  :disabled="con.condition_type == 'Free'" 
                  type="number" class="form-control" />
                <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.freeItem.'+i+'.price')">
                  {{ errors.first('condition.' + index + '.free_item.'+i+'.price') }}
                </div>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="ts-text-red-700 hover:ts-text-red-700"
                  @click.prevent="removeSubItem(index, i)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
    <!-- show product list pop-up -->
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="$t('promotion.buyProduct')"
      :footer="null"
    >
      <ProductList v-model="model" />
    </a-modal>
    <a-modal
      v-if="show_sub_form"
      v-model="show_sub_form"
      :title="$t('promotion.freeProduct')"
      :footer="null"
    >
      <ProductFreeList v-model="subFree" />
    </a-modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './modal-popup/buy-item-product-list.vue'
import ProductFreeList from './modal-popup/free-item-product-list.vue'
export default {
  name: 'buyItemFreeItemCondition',
  props: ['value', 'validate'],
  components: {
    ProductList,
    ProductFreeList
  },
  data() {
    return {
      errors: new Errors(),
      model: {},
      show_form: false,
      show_sub_form: false,
      subFree: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapGetters('promotion/resource', [
      'getProductBuy',
      'getProductFree',
      'getPrice',
      'getProductName'
    ]),
  },
  methods: {
    addItem() {
      this.show_form = true
      // this.model.condition.push(_.cloneDeep(this.row))
    },
    addSubItem(row) {
      this.show_sub_form = true
      this.subFree = row
    },
    removeItem(index) {
      this.model.condition.splice(index, 1)
    },
    removeSubItem(mainIndex, subIndex) {
      this.model.condition[mainIndex].freeItem.splice(subIndex, 1)
    },
    conditionTypeChange(row) {
      if (row.condition_type == 'Free') {
        row.freeItem.forEach(element => {
          element.price = 0
        }); 
      } else {
        row.freeItem.forEach(element => {
          element.price = this.getPrice(element.pro_sale_code_id_free)
        }); 
      }
    },
    productFreeChange(status, row) {
      if (status != 'Free') {
        row.price = this.getPrice(row.pro_sale_code_id_free)
      }
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>
<style lang="css" scoped>
table {
  border-collapse: collapse;
  border-radius: 0.5em;
  overflow: hidden;
}
table thead tr th {
  border: 1px solid #e2e8f0;
  padding: 3px 7px;
}
/* table tbody tr td {
		border: 1px solid #e2e8f0;
		padding: 3px 7px;
	} */
</style>